export default (name = '') => {
  const names = name.trim().split(' ')
  const firstName = names.shift()
  const lastName = names.join(' ')
  return { firstName, lastName }
}
